/* eslint-disable no-console */
import { register } from 'register-service-worker';

// Registro del service worker generado por @vue/cli-plugin-pwa (Workbox).
// Solo activo en producción; en desarrollo Vue CLI no genera service worker.
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('PWA lista: contenido servido desde caché.');
    },
    registered() {
      console.log('Service worker registrado.');
    },
    cached() {
      console.log('Contenido cacheado para uso sin conexión.');
    },
    updatefound() {
      console.log('Descargando nueva versión de la aplicación...');
    },
    updated(registration) {
      console.log('Nueva versión disponible; se aplicará al recargar.');
      // Notificar a la app por si quiere mostrar un aviso de actualización.
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    },
    offline() {
      console.log('Sin conexión: la aplicación funciona en modo caché.');
    },
    error(error) {
      console.error('Error al registrar el service worker:', error);
    },
  });
}
